<script lang="ts">
import { computed, defineComponent, reactive, watch } from 'vue'
import LogoChildRender from './child/LogoChild.vue'
import { useCustomization } from '@/hooks/useCustomization'
import { useEnhancer } from '@/app/enhancer'
import CardHeader from '@/components/ui/card/CardHeader.vue'
export default defineComponent({
  name: 'GoLogo',
  components: { CardHeader, LogoChildRender },
  emits: ['ok', 'back'],
  setup(_, { emit }) {
    const customization = useCustomization()
    const { storeFavorites } = useEnhancer()

    const previousKeep = reactive({
      logoFrontColor: '',
      logoBackColor: '',
    })

    const logo = reactive({
      logoFrontColor: '',
      logoBackColor: '',
    })

    const renderList = computed(() => {
      return customization.getLogoOptions.value.map((option) => {
        const key = option.key
        const switcherActionKey
          = key === 'logoFrontColor'
            ? 'logo_front_display_switcher'
            : 'logo_back_display_switcher'
        const colorActionKey
          = key === 'logoFrontColor'
            ? 'logo_front_color_switcher'
            : 'logo_back_color_switcher'
        return {
          key: option.key,
          label: option.label,
          switcherActionKey,
          colorActionKey,
          url: option.url,
          value: logo[key],
          isShow: computed(() => logo[key] !== '').value,
          disabled: computed(() => {
            const logoEnabled = storeFavorites.selectedModel?.logoEnabled
            if (
              key === 'logoFrontColor'
              && (logoEnabled === 'both' || logoEnabled === 'front')
            )
              return false

            if (
              key === 'logoBackColor'
              && (logoEnabled === 'both' || logoEnabled === 'back')
            )
              return false

            return true
          }).value,
        }
      })
    })

    watch(
      () => storeFavorites.selectedLogo,
      (newValue) => {
        // const selectedLogo = storeFavorites.selectedLogo;
        logo.logoFrontColor = newValue.logoFrontColor
        logo.logoBackColor = newValue.logoBackColor
      },
      {
        immediate: true,
      },
    )

    const triggerChange = (key: string, value: string) => {
      storeFavorites.setCurrentConfig(key, value)
    }

    const handleChange = (key: string, value) => {
      logo[key] = value
      triggerChange(key, value)
    }

    const toggleLogo = (key: string, value) => {
      if (value) {
        logo[key] = !previousKeep[key] ? 'white' : previousKeep[key]
        previousKeep[key] = ''
      }
      else {
        previousKeep[key] = logo[key]
        logo[key] = ''
      }
      triggerChange(key, logo[key])
    }

    return {
      logo,
      renderList,
      handleChange,
      toggleLogo,
      handleClose: () => {
        emit('back')
      },
    }
  },
})
</script>

<template>
  <div class="animate_500">
    <CardHeader
      title="LOGO"
      description="ロゴ"
      hidden-left
      @close="handleClose"
    />
    <div class="row full-height q-pl-md q-pb-sm">
      <LogoChildRender
        v-for="item in renderList"
        :key="item.key"
        :item="item"
        @toggle-logo="(payload) => toggleLogo(payload.key, payload.value)"
        @handle-change="(payload) => handleChange(payload.key, payload.value)"
      />
    </div>
  </div>
</template>
